import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageHeading from "../common/PageHeading";
import GalleryCardPC from "../common/GalleryCardPC";
import ImageGallery from "../gallery-image/ImageGallery";
import DashboardCardMobile from "../common/DashboardCardMobile";
import GalleryCardMobile from "../common/GalleryCardMobile";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";
import { motion } from "framer-motion";

const Photos = ({ closePhotos }) => {
	const { id } = useParams();
	const [response, setResponse] = useState([]);
	const [backgroundImageWeb, setBackgroundImageWeb] = useState([]);
	const [currentImageIndexWeb, setCurrentImageIndexWeb] = useState(0);
	const [photoArr, setPhotoArr] = useState([]);
	const [videoArr, setVideoArr] = useState([]);
	const [isSticky, setIsSticky] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const [isPhotoSlideIn, setPhotoIsSlideIn] = useState(false);
	const [openedImage, setOpenedImage] = useState(false);
	const [handleSlideInvideo, sethandleSlideInforVideos] = useState(false);
	const [isImageLoaded, setIsImageLoaded] = useState(true);
	const [isBlurred, setIsBlurred] = useState(true);

	let NewUsername = "";
	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
	console.log(newImgUrl);

	const pathParts = location.pathname.split("/").filter(Boolean);
	const username = pathParts[0];
	let animationFrameId = null;
	useEffect(() => {
		if (backgroundImageWeb.length > 0) {
			const timer = setTimeout(() => setIsBlurred(false), 100); // slight delay
			return () => clearTimeout(timer);
		}
	}, [backgroundImageWeb]);
	useEffect(() => {
		const fetchPhoto = async () => {
			try {
				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: id,
					category: "Gallery"
				});
				console.log(res);
				if (res) {
					setResponse(res);
					setPhotoArr(res.photosAlbums);
					setVideoArr(res.videosAlbums);
					setBackgroundImageWeb(res.basicDetails.sliderImgsMob);
				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};

		fetchPhoto();
	}, [])

	useEffect(() => {

		const handleScroll = () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
			animationFrameId = requestAnimationFrame(() => {
				const outerElement = document.querySelector('.scroll-bar');
				if (outerElement) {
					const scrollPosition = outerElement.scrollTop;
					setIsSticky(scrollPosition > 0);
				}
			});
		};

		const outerElement = document.querySelector('.scroll-bar');
		if (outerElement) {
			outerElement.addEventListener('scroll', handleScroll);
			handleScroll(); // Initial check

			return () => {
				outerElement.removeEventListener('scroll', handleScroll);
				if (animationFrameId) {
					cancelAnimationFrame(animationFrameId);
				}
			};
		}
	}, []);



	const handleSlideIn = (slug) => {
		// navigate(`/GalleryImage/${id}/${encodeURIComponent(slug)}`);
		if (!isPhotoSlideIn) {
			localStorage.setItem("myValue", JSON.stringify(true));
			window.history.pushState({ isPhotoSlideIn: false, username: username, id: id, slug: slug }, "", `/${username}/GalleryImage/${id}/${slug}`);
		} else {
			window.history.back({ isPhotoSlideIn: false });

		}
		console.log("photos useeffect", isPhotoSlideIn)
		setPhotoIsSlideIn(!isPhotoSlideIn);
	};
	useEffect(() => {
		const currentPath = window.location.pathname;

		if (!currentPath.includes('/GalleryImage')) {
			console.log("url Name ", currentPath);
			const handlePopState = () => {
				if (isPhotoSlideIn) {
					setPhotoIsSlideIn(false);
				}
			};
			window.addEventListener("popstate", handlePopState);

			return () => {
				window.removeEventListener("popstate", handlePopState);
			};
		}

	}, [isPhotoSlideIn,]);

	//   const handleSlideIn = () => {
	// 	if (!isSlideIn) {
	// 	  window.history.pushState({ isSlideIn: true }, "", "/photos");
	// 	} else {
	// 	  window.history.back();
	// 	}
	// 	setIsSlideIn(!isSlideIn);
	//   };

	// const slideStyles = (type) => ({
	// 	transform: activeSlide === type ? "translateX(0)" : "translateX(100%)",
	// 	opacity: activeSlide === type ? 1 : 0,
	// 	transition: "transform 500ms ease-in-out, opacity 500ms ease-in-out",
	//   });


	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentImageIndexWeb((prev) =>
				prev === backgroundImageWeb.length - 1 ? 0 : prev + 1
			);
		}, 4000);
		return () => clearInterval(interval);
	}, [backgroundImageWeb.length]);
	const containerVariants = {
		hidden: {},
		show: {
			transition: {
				staggerChildren: 0.2,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		show: { opacity: 1, y: 0, transition: { duration: 0.2, ease: "easeOut" } },
	};
	return (
		<div id="home"
			style={{
				zIndex: "9999999999",
				backgroundColor: "white",
				position: "relative",
			}}>
			<div
				className={`${isPhotoSlideIn ? "translate-x-0" : "translate-x-full"
					} fixed top-0 right-0 w-full h-full bg-black/70 z-[100] `}
				style={{
					backgroundColor: "white",
					opacity: isPhotoSlideIn ? 1 : 0,
					minHeight: "100svh !important",
					transition: "transform 500ms ease-in-out, opacity 500ms ease-in-out",
				}}
			>
				<div className="">
					{isPhotoSlideIn && <ImageGallery />}
				</div>
			</div>
			<div className="hidden sm:block">
				<div className="container-fluid p-0">
					<div className="grid grid-cols-12 h-screen">
						<div className="col-span-5 relative h-screen overflow-hidden">
							{backgroundImageWeb?.length > 0 &&
								backgroundImageWeb.map((img, index) => (
									<img
										key={img}
										src={newImgUrl + img}
										className={`w-full h-full relative z-[-1] object-cover crossFade__image ${currentImageIndexWeb === index ? 'crossFade__image--active' : ''
											}
									transition-all duration-1000 ${(backgroundImageWeb?.length > 0 && isImageLoaded) ? "blur-lg scale-105" : "blur-0 scale-100"
											}
									`}
										onLoad={() => setIsImageLoaded(false)}



										alt=""
									/>
								))}
							<div
								className="absolute top-0 w-full h-full py-[40px] px-[40px]"
								style={{
									background:
										"linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(59,59,59,0.4) 50%, rgba(0,0,0,0.9) 100%)",
								}}
							>
								<div className="w-full h-full flex justify-center items-center border-[3px] border-white text-center">
									<p className="text-white text-[70px] font-['Baby_Giovani_Script'] m-0">
										Gallery
									</p>
								</div>
							</div>
						</div>
						<div className="col-span-7">

							<div className="h-screen overflow-x-auto scroll-bar" >
								<div className={`m-0 py-2 w-full w-full stickynav ${isSticky ? "isSticky" : "hideinmobile"}`} style={{ position: 'sticky', top: 0, zIndex: '1', backgroundColor: 'white', textAlign: 'center' }}>
									<PageHeading title={"Photos"} backTo={`/${username}/Gallery/${id}`} />
								</div>
								<motion.div
									key={location?.pathname}

									className="flex flex-col "
									variants={containerVariants}
									initial="hidden"
									animate={photoArr.length ? "show" : "hidden"}
								>
									<div className="col-lg-12 d-flex justify-center pt-10 mb-3">

										<div className="grid grid-cols-1 lg:grid-cols-2 w-100 gap-10 px-10">

											{photoArr && photoArr.map((item, index) => {
												const albumId = item.albumLink && item.albumLink[0] ? item.albumLink[0].split('/').pop() : id;
												return (
													<motion.div
														key={index}
														variants={itemVariants}
														className="  items-start whiteripple cursor-pointer"
													>
														<GalleryCardPC
															paramid={id}
															data={{ title: item.albumName, cardBgImage: newImgUrl + item.albumBg }}
															title={"Pre Wedding"}
															cardBgImage={item}
															photos={true}
															slug={item.albumName}
															username={username}
															id={albumId}
														// HandleOnclick={() => handleSlideIn(item.albumName)}
														/>
													</motion.div>
												)
											})}

										</div>

									</div>
								</motion.div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="block sm:hidden h-dvh">
				<div className="h-full container-fluid bg-black p-0 ">
					<div className="h-full ">
						<div className="col-lg-7 col-md-6 col-sm-6 h-full">
							<div className="h-full overflow-x-auto scroll-bar">
								<div className="">
									<motion.div
										className="flex flex-col "
										variants={containerVariants}
										initial="hidden"
										animate={photoArr.length ? "show" : "hidden"}
									>
										<div className="p-[12px] px-[1] py-[7px]">
											{photoArr && photoArr.map((item, index) => {
												const albumId = item.albumLink && item.albumLink[0] ? item.albumLink[0].split('/').pop() : id;
												return (
													<motion.div
														key={index}
														variants={itemVariants}
														className="  items-start whiteripple cursor-pointer"
													>
														<GalleryCardMobile
															key={item}
															id={albumId}
															data={{ title: item.albumName, cardBgImage: newImgUrl + item.albumBg }}
															title={"Pre Wedding"}
															cardBgImage={item}
															video={false}
															// HandleOnclick={() => handleSlideIn(item.albumName)}
															isAlbum={false}
															slug={item.albumName}
															username={username}
														/>
													</motion.div>
													// <GalleryCardMobile
													// 	key={item}
													// 	title={"Pre Wedding"}
													// 	backgroundImageUrl={item}
													// 	HandleOnclick={handleSlideIn}
													// 	isAlbum={false}
													// />
												)
											})}
										</div>
									</motion.div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Photos;
